import { render } from "./LoadingMask.vue?vue&type=template&id=0de9098d&scoped=true&ts=true"
import script from "./LoadingMask.vue?vue&type=script&lang=ts"
export * from "./LoadingMask.vue?vue&type=script&lang=ts"

import "./LoadingMask.vue?vue&type=style&index=0&id=0de9098d&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de9098d"]])

export default __exports__